module.exports = __webpack_public_path__ + "static/js/1.da0dcc27.chunk.worker.js"